import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Referee } from "../../types/types";

// Define a type for the slice state
interface RefereesState {
  referees: Array<Referee>;
  editingReferee?: Referee;
}

// Define the initial state using that type
const initialState: RefereesState = {
  referees: [],
  editingReferee: undefined,
};

export const RefereesSlice = createSlice({
  name: "referees",
  initialState,
  reducers: {
    setReferees: (state, action: PayloadAction<Array<Referee>>) => {
      state.referees = action.payload.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    },
    setEditingReferee: (state, action: PayloadAction<Referee | undefined>) => {
      state.editingReferee = action.payload;
    },
    removeReferee: (state, action: PayloadAction<string>) => {
      state.referees = state.referees.filter(referee => referee.id !== action.payload);
    },
    updateReferee: (state, action: PayloadAction<Referee>) => {
      state.referees = state.referees.map(referee => referee.id === action.payload?.id ? action.payload : referee
      )
    }
  },
});

export const { setReferees, setEditingReferee, removeReferee, updateReferee } = RefereesSlice.actions;

export default RefereesSlice.reducer;
